var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.164,
    height: 18.029,
    viewBox: "0 0 18.164 18.029",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.657,1.3l1.6,3.2a1.964,1.964,0,0,0,1.284.945l2.895.484c1.853.315,2.289,1.647.957,2.98l-2.253,2.253a1.977,1.977,0,0,0-.472,1.647l.642,2.8c.509,2.2-.666,3.064-2.616,1.914L9.978,15.907a1.951,1.951,0,0,0-1.793,0L5.472,17.518c-1.95,1.151-3.125.291-2.616-1.914l.642-2.8a2,2,0,0,0-.472-1.647L.773,8.906c-1.332-1.332-.9-2.677.957-2.98l2.895-.484A2,2,0,0,0,5.909,4.5l1.6-3.2C8.367-.433,9.8-.433,10.657,1.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.adbff1112400041ed96fadbb2038a6a4.svg";
export { ForwardRef as ReactComponent };